import { render, staticRenderFns } from "./wty-template.vue?vue&type=template&id=c2e586ec&scoped=true&"
import script from "./wty-template.vue?vue&type=script&lang=js&"
export * from "./wty-template.vue?vue&type=script&lang=js&"
import style0 from "./wty-template.vue?vue&type=style&index=0&id=c2e586ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e586ec",
  null
  
)

export default component.exports